<template>
  <div v-if="visible" class="loading-overlay">
    <div class="spinner" :style="{ width: size, height: size, borderColor: color }"></div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: '50px'
    },
    color: {
      type: String,
      default: 'blue' // Replace 'primary' with a default color like 'blue'
    }
  }
}
</script>

<style lang="scss">

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
